import { useState } from 'react'
import { Button } from '@/components/Button'
import { PhoneIcon } from '@/components/Icons'
import SpecialistDialog from '@/components/SpecialistDialog'

export const SpecialistCard = ({ specialist, onRequestCallback }) => {
  const [open, setOpen] = useState(false)

  const onClose = () => setOpen(false)

  return (
    <>
      <article className='space-y-4 w-full max-w-[360px] sm:max-w-[340px] mx-auto flex flex-col'>
        {/* Profile Picture */}
        <figure className='flex max-w-[200px] mx-auto'>
          <img
            src={specialist.Media?.Image?.Url || '/find-a-specialist-default.png'}
            alt={specialist.Media?.Image?.AltText || `${specialist.Name} profile picture`}
            className='w-full aspect-square rounded-lg object-cover'
            onError={(e) => {
              e.target.src = '/find-a-specialist-default.png'
            }}
          />
        </figure>

        {/* Specialist Information */}
        <header className='space-y-1 text-center'>
          <h3 className='text-default-900 font-extrabold text-xl'>
            {specialist.Name}
          </h3>
          <div data-spacer />
          <p className='text-base font-semibold mb-2 text-pretty'>
            {specialist.Role}
          </p>
          <a
            href={`tel:${specialist.PhoneNumber}`}
            className='block text-base font-extrabold'
          >
            {specialist.PhoneNumber}
          </a>
        </header>

        {/* Contact Information */}
        {(specialist.Email || specialist.AboutSpecialist) && (
          <div className='space-y-3 flex flex-col gap-2 grow justify-end'>
            {specialist.AboutSpecialist && (
              <div className='flex justify-center'>
                <button
                  onClick={() => setOpen(true)}
                  className='text-primary-500 hover:text-primary-700 underline text-base font-extrabold'
                >
                  {/* Return only first name from Name */}
                  Learn More About {specialist.Name.split(' ')[0]}
                </button>
              </div>
            )}
            {/* Request Callback Button */}
            <Button onClick={() => onRequestCallback(specialist)} variant='secondary' size='sm'>
              <span className='flex items-center gap-2'>
                <PhoneIcon className='size-4' /><span>Request a callback</span>
              </span>
            </Button>
          </div>
        )}
      </article>
      <SpecialistDialog open={open} onClose={onClose} specialist={specialist} />
    </>
  )
}
